import { useApi } from "../../../swr/useApi";
import {
  bestDealsService,
  type BestDealsQuery,
  type BestDealsResponse,
} from "../../api_client";

export function useBestDeals(query?: BestDealsQuery) {
  const cacheKey = query ? `best-deals-${JSON.stringify(query)}` : "best-deals";

  return useApi<BestDealsResponse>(
    cacheKey,
    () => bestDealsService.getBestDeals(query),
  );
}
